export default {

  // 纯字母
  letter (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^[a-z]+$/i
    if (!reg.test(value)) {
      return callback(new Error('请输入纯字母格式'))
    }
    callback()
  },

  // 纯数字
  digital (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^[0-9]+$/
    if (!reg.test(value)) {
      return callback(new Error('请输入纯数字格式'))
    }
    callback()
  },

  // 变量名
  varname (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^\w+$/
    if (!reg.test(value)) {
      return callback(new Error('请输入变量名格式'))
    }
    callback()
  },

  // 字母数字
  letterDigital (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^[a-z0-9]+$/i
    if (!reg.test(value)) {
      return callback(new Error('请输入字母和数字格式'))
    }
    callback()
  },

  // 字母数字字符
  letterDigitalSymbol (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    // eslint-disable-next-line no-useless-escape
    let reg = /^[a-z0-9~!@%^&*_+`=#()$/\-\.\s{}\[\]\|\\:;'"<>,./\?]+$/i
    if (!reg.test(value)) {
      return callback(new Error('输入的格式不正确格式'))
    }
    callback()
  },

  // 金额
  amount (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^[0-9]+(\.[0-9][0-9]?)?$/
    if (!reg.test(value)) {
      return callback(new Error('请输入金额格式'))
    }
    callback()
  },

  // 手机号
  mobile (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^1[0-9]{10}$/
    if (!reg.test(value)) {
      return callback(new Error('请输入手机号格式'))
    }
    callback()
  },

  // 中文
  chinese (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]+$/
    if (!reg.test(value)) {
      return callback(new Error('请输入中文格式'))
    }
    callback()
  },

  // ip地址
  ipAddress (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/
    if (!reg.test(value)) {
      return callback(new Error('请输入IP格式'))
    }
    callback()
  },

  // ip地址
  ips (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^(([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3}|\*)[,;])*(([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3}|\*))$/
    if (!reg.test(value)) {
      return callback(new Error('请输入IP格式'))
    }
    callback()
  },

  // url地址
  url (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^(\w+:\/\/)?[\w-]+(\.[\w-]+)+.*$/
    if (!reg.test(value)) {
      return callback(new Error('请输入url格式'))
    }
    callback()
  },

  // 密码
  password (rule, value, callback) {
    if (!value) {
      callback()
      return
    }
    let reg = /^.*(?=.{8,32})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,}).*$/
    if (!reg.test(value)) {
      return callback(new Error('8位-32位，必须包含大写字母、小写字母、数字'))
    }
    callback()
  }
}
